import { render, staticRenderFns } from "./JsonTreeField.vue?vue&type=template&id=7b0ffc8c"
import script from "./JsonTreeField.vue?vue&type=script&lang=ts"
export * from "./JsonTreeField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports